__turbopack_context__.v({
  "container": "AV-U6W_container",
  "item": "AV-U6W_item",
  "nav": "AV-U6W_nav",
  "navBtn": "AV-U6W_navBtn",
  "navBtnLeft": "AV-U6W_navBtnLeft",
  "navBtnRight": "AV-U6W_navBtnRight",
  "progress": "AV-U6W_progress",
  "rail": "AV-U6W_rail",
  "thumb": "AV-U6W_thumb",
  "track": "AV-U6W_track",
  "viewport": "AV-U6W_viewport",
});
